export default __webpack_public_path__ + "static/white-matrix-ab5bc05520fa8779c98ebead53f87dd7.svg";